import { Component, Input, Output, EventEmitter } from "@angular/core";
import { VAIconRegistryService, fileExcel } from "@va/core-library/icons";
import { faSpinner } from "@fortawesome/pro-light-svg-icons";
/**
 * This component represents "Excel to export dropdown"
 * This component provides dropdown. Upon clicking the list item the selected items id gets emitted
 */
@Component({
  selector: "app-export-to-excel-dropdown",
  templateUrl: "./export-to-excel-dropdown.component.html",
  styleUrls: ["./export-to-excel-dropdown.component.scss"],
})
export class ExportToExcelDropdownComponent {
  @Input() isPopoverVisible = false;
  @Input() label = "Export";
  @Input() optionList: Array<{ label: string; id: number; disabled: boolean }>;
  @Input() disabled = false;
  @Input() isExportInProgress = false;
  @Input() class = "";
  @Input() size: "sm" | "lg" = "sm";
  @Input() title = "Export";
  @Output() onListItemClick: EventEmitter<any> = new EventEmitter();
  @Output() isPopoverVisibleChange: EventEmitter<any> = new EventEmitter();

  // icons
  faSpinner = faSpinner;
  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([fileExcel]);
  }

  /**
   * Executes on click of list item and emits the id of selected item
   * @param {id} number Indicates the id of selected list item from optionList
   */
  handleListItemClick(id) {
    this.onListItemClick.emit(id);
  }

  /**
   * Informs and emits the visibility state of dropdown
   * This is used for two way binding
   * @param {boolean} isVisible Indicates if dropdown is visible or not
   */
  handlePopupVisibilityChange(isVisible) {
    this.isPopoverVisibleChange.emit(isVisible);
  }
}
